import { getDocumentApi, getDocumentGoodApi, postDocumentGoodApi, deleteDocumentGoodApi } from "@/apis/document";
import { GetApiClient, PostApiClient, DeleteApiClient } from "@/utils/api-client";

export class DocumentUsecase {
  static document(apiClient: GetApiClient, documentId: string) {
    return getDocumentApi(apiClient, documentId);
  }

  static documentGood(apiClient: GetApiClient, documentId: string) {
    return getDocumentGoodApi(apiClient, documentId);
  }

  static addDocumentGood(apiClient: PostApiClient, documentId: string) {
    return postDocumentGoodApi(apiClient, documentId);
  }

  static deleteDocumentGood(apiClient: DeleteApiClient, documentId: string) {
    return deleteDocumentGoodApi(apiClient, documentId);
  }
}
